import type { ContentsCarousel } from '../../../domain/ContentsCarousel'
import type { ContentsCarouselDTO } from '../../../domain/ContentsCarouselDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'
import type { ContentPage } from '../../../../content-page/domain/ContentPage'
import type { PartnerId } from '../../../../../types/PartnerId'

import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapContentsCarouselFromApi = (
  dto: ContentsCarouselDTO,
  partnerId?: PartnerId,
): ContentsCarousel | undefined => {
  if (
    !(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerName && [dto.fields.partnerName]))
  ) {
    return undefined
  }

  const {
    anchorLabel,
    articles,
    backgroundColor,
    buttonLabel,
    buttonUrl,
    description,
    isManual,
    helpTagArticleThumbnails,
    highlighted,
    title,
  } = dto.fields

  return {
    anchorLabel,
    articles: mapEntryDTOList<ContentPage>(articles),
    backgroundColor,
    buttonLabel,
    buttonUrl,
    contentType: ContentModelId.CONTENTS_CAROUSEL,
    description,
    isManual,
    helpTagArticleThumbnails,
    highlighted,
    title,
  }
}
